import api from '../axios.js'


export let tipoCambio=async()=>{
	let datos = await api(`/tipoCambio`);
	let tipocambios=datos.data;
	return tipocambios
};


export let setLocation=async()=>{

	
	let rsp= await api(`/usuario/ubicacion`);
	 	 	
	 	 		switch(rsp.data.country_name.toLowerCase()){
	 	 			case "peru":
	 	 				return {nombre:"Peru",moneda:"Soles",monedaIcono:"S/",ISO:"PEN",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Peru.svg/1024px-Flag_of_Peru.svg.png"}; 			
	 	 			case "argentina":
	 	 				return {nombre:"Argentina",moneda:"Pesos",monedaIcono:"$",ISO:"ARS",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/1280px-Flag_of_Argentina.svg.png"};
	 	 				
	 	 			case "bolivia":
	 	 				return {nombre:"Bolivia",moneda:"Bolivianos",monedaIcono:"Bs",ISO:"BOB",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Bolivia.svg/1024px-Flag_of_Bolivia.svg.png"};
	 	 				
	 	 			case "chile":
	 	 				return {nombre:"Chile",moneda:"Pesos",monedaIcono:"$",ISO:"CLP",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/1024px-Flag_of_Chile.svg.png"};
	 	 			
	 	 			case "colombia":
	 	 				return {nombre:"Colombia",moneda:"Pesos",monedaIcono:"$",ISO:"COP",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Colombia.svg/1024px-Flag_of_Colombia.svg.png"};
	 	 				
	 	 			case "mexico":
	 	 				return {nombre:"Mexico",moneda:"Pesos",monedaIcono:"$",ISO:"MXN",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/135px-Flag_of_Mexico.svg.png"};
	 	 				
	 	 			case "uruguay":
	 	 				return {nombre:"Uruguay",moneda:"Pesos",monedaIcono:"$",ISO:"UYU",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Uruguay.svg/1024px-Flag_of_Uruguay.svg.png"};
	 	 				
	 	 			default:
	 	 				return {nombre:"resto",moneda:"Dolar",monedaIcono:"$",ISO:"USD",bandera:"https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/International_Flag_of_Planet_Earth.svg/1024px-International_Flag_of_Planet_Earth.svg.png"};
	 	 		}	 	
	 	 			 	 		
}

export let mobile=()=>{
	if( navigator.userAgent.match(/Android/i)
				|| navigator.userAgent.match(/webOS/i)
 				|| navigator.userAgent.match(/iPhone/i)
 				|| navigator.userAgent.match(/iPad/i)
 				|| navigator.userAgent.match(/iPod/i)
 				|| navigator.userAgent.match(/BlackBerry/i)
 				|| navigator.userAgent.match(/Windows Phone/i))
		{return true}
		else return false
}

export let getFechaLocal=()=>{
	const now = new Date();
	console.log(now);
	const yyyy = now.getFullYear();
	const mm = String(now.getMonth() + 1).padStart(2, "0");
	const dd = String(now.getDate()).padStart(2, "0");
	const hh = String(now.getHours()).padStart(2, "0");
	const mi = String(now.getMinutes()).padStart(2, "0");
	const ss = String(now.getSeconds()).padStart(2, "0");

	return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}

export let formatFecha=(date)=>{
	const now = new Date(date);
	
	const yyyy = now.getFullYear();
	const mm = String(now.getMonth() + 1).padStart(2, "0");
	const dd = String(now.getDate()).padStart(2, "0");
	const hh = String(now.getHours()).padStart(2, "0");
	const mi = String(now.getMinutes()).padStart(2, "0");
	const ss = String(now.getSeconds()).padStart(2, "0");

	return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}